/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * Transforms a webpage object from the API to the format expected by EventCard component
 * @param {Object} webpage - The webpage object from the API
 * @returns {Object} - Transformed event object with date, title, start_time, end_time, description, timezone
 */
export const transformWebpageToEvent = (webpage) => {
    if (!webpage) {
        return {};
    }

    // Helper function to extract field value from fields array
    // Fields can be in webpage.fields or webpage.modelObject.fields
    const getFieldValue = (fieldName) => {
        const fields = webpage.modelObject?.fields || webpage.fields;
        
        if (!fields || !Array.isArray(fields)) {
            return null;
        }
        
        const field = fields.find((f) => f.name === fieldName);
        if (!field || !field.values || !field.values[0]) {
            return null;
        }
        
        return field.values[0].value;
    };

    // Extract date from event_date field
    const eventDateField = getFieldValue("event_date");
    const date = eventDateField?.date || eventDateField || null;
    
    // Extract timezone from event_date or start_time field
    const timezone = eventDateField?.tz || getFieldValue("start_time")?.tz || null;

    // Extract start_time
    const startTimeField = getFieldValue("start_time");
    const startTime = startTimeField?.date || startTimeField || null;

    // Extract end_time
    const endTimeField = getFieldValue("end_time");
    const endTime = endTimeField?.date || endTimeField || null;

    // Extract title (prefer nav_title, fallback to model_title)
    const title = webpage.nav_title || webpage.model_title || null;

    // Extract description
    const description = webpage.description || null;

    return {
        id: webpage.id,
        guid: webpage.guid,
        date,
        title,
        start_time: startTime,
        end_time: endTime,
        description,
        timezone,
    };
};

